import { appRouterPaths } from 'services/navigation';
import { MunicipalitiesPage } from 'pages/Municipalities';
import type { AppRouteProps } from '../types';

export const municipalitiesPageRoute: AppRouteProps = {
  path: appRouterPaths.municipalities,
  element: <MunicipalitiesPage />,
};
